import { useState } from 'react';
import { FEATURE_COUNTS, VIDEO_SAMPLES } from './catalog';
import { SampleVideoPlayer } from './SampleVideoPlayer';
import { SAMPLE_DURATION_SECONDS, SAMPLE_SECTION_LABEL } from './settings';
import './samples.css';

export function VideoSamples({ compact = false }: { compact?: boolean }) {
  const [selected, setSelected] = useState(VIDEO_SAMPLES[0]!);
  return <section className={`sample-gallery${compact ? ' sample-gallery-compact' : ''}`} aria-labelledby="sample-heading">
    <div className="sample-section-heading"><span className="eyebrow">See the finished video</span>
      <h2 id="sample-heading">{compact ? '30 seconds. Three formats.' : "Three format — the best for sharing your adventures"}</h2>
      {!compact && <p>Every format exports as a 1080p MP4, ready to download and post.</p>}</div>
    <div className="sample-gallery-grid">
      <SampleVideoPlayer key={selected.id} src={selected.src} width={selected.output.width} height={selected.output.height}
        label={selected.label.toLowerCase()} description={`${selected.label} sample: ${selected.map} map with ${selected.camera} camera`} />
      <div className="sample-format-list"><div role="group" aria-label="Sample video format">
        {VIDEO_SAMPLES.map(sample => <button key={sample.id} type="button" aria-pressed={selected.id === sample.id}
          onClick={() => setSelected(sample)}>
          <span className="sample-format-title"><strong>{sample.label}</strong><span>{sample.ratio}</span></span>
          <span>{sample.platforms}</span>
          <small>{sample.output.width} × {sample.output.height}</small>
        </button>)}
      </div><p className="sample-caption">{selected.platforms}<br />{selected.map} map · {selected.camera} camera<br />{selected.id === 'landscape' ? 'Times Square to World Trade Center · 3.83-mile trace' : SAMPLE_SECTION_LABEL} · {SAMPLE_DURATION_SECONDS} seconds<br />Silent video · 30 fps</p>
        {!compact && <p className="sample-caption"><a href="/samples#social">Go ahead and try different layouts and overlay opacity →</a></p>}
        <a className="sample-map-link" href="/samples#maps">Watch all {FEATURE_COUNTS.maps} the previews →</a>
      </div>
    </div>
  </section>;
}
